import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { GetStaticPropsContext } from 'next/types'
import { JargonPageStoryContent } from './types'

interface GetStaticPropsGeneratorArgs {
  path: string
}

export const getStaticPropsGenerator =
  ({ path }: GetStaticPropsGeneratorArgs) =>
  async ({ params, preview = false }: GetStaticPropsContext) => {
    try {
      const slug = params?.slug as string

      const story = await getStoryBySlug<JargonPageStoryContent>(
        `${path}/${slug}`,
        {
          version: preview ? 'draft' : 'published',
          cv: Date.now(),
          resolve_relations: 'JargonPage.relatedJargon',
        },
      )

      if (!story) {
        throw new Error('No story within jargon')
      }

      return {
        props: {
          story,
          preview,
          layoutProps: {
            showBorderRadius: true,
          },
        },
        revalidate: 60, // In seconds
      }
    } catch (error) {
      console.log(error)
      return {
        notFound: true,
        props: {
          story: null,
          preview,
          layoutProps: {
            showBorderRadius: true,
          },
        },
        revalidate: 60,
      }
    }
  }

export type JargonFeatureProps = Extract<
  Awaited<ReturnType<ReturnType<typeof getStaticPropsGenerator>>>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { props: any }
>['props']
